import Main from 'components/Main';

//import Select from 'components/Select';
//import TextArea from 'components/TextArea';

import './index.less';
import './themes/default.less';

export default class SMS extends Main {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            smsId: null,
        };
    }

    refresh() {
        this.forceUpdate();
    }

    render() {
        //const { smsId } = this.state;
        //const { smsTemplateList } = this._helper.getCurrClinic();
        //const items = smsTemplateList || [];

        //const selectedId = smsId || items[0].id;
        //const selected = items.find(it => it.id === selectedId);
        //const smsText = selected.template || selected.defaultTemplate;

        return (
            <div className="sms flex flex1 col gap16">
                {/*<div className="flex centerV gap8">
                    <div className="text p1">{this.tr("main.template")}</div>
                    <Select
                        value={selectedId}
                        showLeftIcon={false}
                        items={items}
                        onChange={this.changeState.bind(this, "smsId")}
                    />
                </div>
                <TextArea value={smsText} />*/}
            </div>
        );
    }
}
